import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  html {
    box-sizing: border-box;
  }

  html, body {
    margin: 0px;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }
`;
